"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimelineItemTimestamp = getTimelineItemTimestamp;
exports.timelineItemComparator = timelineItemComparator;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _get = _interopRequireDefault(require("transmute/get"));

var _isEngagementEvent = require("crm_data/engagements/isEngagementEvent");

var _getTimelineItemId = require("./getTimelineItemId");

var _getIn = _interopRequireDefault(require("transmute/getIn"));

function getTimelineItemTimestamp(timelineItem) {
  if ((0, _typeof2.default)(timelineItem) !== 'object') {
    return 0;
  }

  return (0, _getIn.default)(['eventData', 'engagement', 'timestamp'], timelineItem) || (0, _getIn.default)(['engagement', 'timestamp'], timelineItem) || (0, _get.default)('timestamp', timelineItem);
}

function timelineItemIdComparator(timelineItemA, timelineItemB) {
  var idA = (0, _getTimelineItemId.getTimelineItemId)(timelineItemA);
  var idB = (0, _getTimelineItemId.getTimelineItemId)(timelineItemB);
  return idA < idB ? 1 : idA > idB ? -1 : 0;
}

function timelineItemComparator(timelineItemA, timelineItemB) {
  var timestampA = getTimelineItemTimestamp(timelineItemA);
  var timestampB = getTimelineItemTimestamp(timelineItemB);

  if (timestampA === timestampB) {
    var itemACreatedAtDate;
    var itemBCreatedAtDate;

    if ((0, _isEngagementEvent.isEngagementEvent)(timelineItemA)) {
      itemACreatedAtDate = (0, _getIn.default)(['eventData', 'engagement', 'createdAt'], timelineItemA);
    }

    if ((0, _isEngagementEvent.isEngagementEvent)(timelineItemB)) {
      itemBCreatedAtDate = (0, _getIn.default)(['eventData', 'engagement', 'createdAt'], timelineItemB);
    }

    if (itemACreatedAtDate && itemBCreatedAtDate) {
      if (itemACreatedAtDate === itemBCreatedAtDate) {
        return timelineItemIdComparator(timelineItemA, timelineItemB);
      }

      return itemACreatedAtDate < itemBCreatedAtDate ? 1 : -1;
    }

    return timelineItemIdComparator(timelineItemA, timelineItemB);
  }

  return timestampA < timestampB ? 1 : -1;
}